import { Layout } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import bgImage from '../assets/images/bg.jpg'
import { RootState } from '../stores'

const { Content } = Layout

interface Props extends RouteProps {
  component: any
}

export const PublicRoute: React.FC<Props> = ({
  component: Component,
  ...rest
}) => {
  const { profile } = useSelector((state: RootState) => state.auth)
  return (
    <Route
      {...rest}
      render={(props) =>
        profile ? (
          <Redirect to="/" />
        ) : (
          <Layout
            style={{
              width: '100%',
              height: '100%',
              backgroundImage: `url(${bgImage})`,
              backgroundSize: '100% 100%',
            }}
          >
            <Content style={{ padding: '0 50px' }}>
              <Component {...props} />
            </Content>
          </Layout>
        )
      }
    />
  )
}
